import React from 'react';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';

// InfoBlocks
import {
  InfoSection,
  TypeBlock,
  FeatureList,
  UsageSteps,
  VideoBlock,
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';


const HeightLimit = () => {
  const typeGroups = [
    {
        title: 'Type1 (5M 형)',
        subtitle: '소형 교량·지하차도 등 비교적 좁은 통과 구간에 적합한 5m 폭 구조',
        items: [
        {
            src: '/images/products/guardrail/height-limit-type11.jpg',
        },
        {
            src: '/images/products/guardrail/height-limit-type12.jpg',
        },
        ],
    },
    {
        title: 'Type2 (10M 형)',
        subtitle: '왕복 2차로 이상 중·대형 구간에 적용 가능한 10m 폭 구조',
        items: [
        {
            src: '/images/products/guardrail/height-limit-type21.jpg',
        },
        {
            src: '/images/products/guardrail/height-limit-type22.jpg',
        },
        ],
    },
    {
        title: 'Type3 (20M 형)',
        subtitle: '다차로 구간 및 대형 교량 등 광폭 구간에 적합한 20m 폭 구조',
        items: [
        {
            src: '/images/products/guardrail/height-limit-type31.jpg',
        },
        {
            src: '/images/products/guardrail/height-limit-type32.jpg',
        },
        ],
    },
    ];

  const features = [
    {
      title: '빠른 개폐 속도',
      bullets: [
      {
        label: (
          <>고속도로 환경에 최적화된 모터 시스템을 적용하여 차량 흐름을 지연 없이 관리</>
        ),
      },
      ]
    },
    {
      title: '높은 내구성',
      bullets: [
      {
        label: (
          <>외부 환경(비, 눈, 먼지, 고온 등)에 강한 소재로 제작되어 장기간 안정적인 사용이 가능함</>
        ),
      },
      ]
    },
    {
      title: '안전 센서 적용',
      bullets: [
      {
        label: (
          <>차량 접근 감지 센서와 안전 장치가 내장되어 있어, 차량 및 보행자 안전을 최우선으로 보호</>
        ),
      },
      ]
    },
    {
      title: '간편한 유지보수',
      bullets: [
      {
        label: (
          <>모듈형 설계로 부품 교체 및 점검이 용이하여 관리 비용과 시간을 절감</>
        ),
      },
      ]
    },
    {
      title: '스마트 제어 시스템',
      bullets: [
      {
        label: (
          <>원격 모니터링 및 제어 기능을 제공하여 도로 관리자가 실시간으로 상태를 확인하고 조작할 수 있음</>
        ),
      },
      ]
    },
  ];

  

  return (
    <>
      <HeroSection
        title={`통과높이 제한시설`}
        subtitle={`단속 외 시간대에도 \n높은 시인성과 안전 효과를 제공합니다`}
        backgroundImage="/images/products/guardrail/height-limit.webp"
        breadcrumbs={[
          { label: '홈', path: '/' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '통과높이 제한시설' },
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={``}
        title={`통과높이 제한시설`}
        description={
          <>
            통과높이 기준을 초과하는 차량의 운행을 제한하기 위해 해당 도로를 통과할 수 있는 차량의 높이를 명시하고 {' '}
            차량의 통과 시 높이를 제한하는 시설물을 설치하여 사고를 방지하는 시설물입니다.
            <br />
            <br />
            과적 차량에 의해 도로 상의 높이 제한 시설물이 파손 또는 변형으로 인해 기능에 문제가 생길 경우 {' '}
            이를 실시간으로 확인하여 신속한 유지보수가 가능합니다.
          </>
        }
        images={[
          '/images/products/guardrail/height-limit-type11.jpg',
          '/images/products/guardrail/height-limit-type12.jpg',
          '/images/products/guardrail/height-limit-type21.jpg',
          '/images/products/guardrail/height-limit-type22.jpg',
          '/images/products/guardrail/height-limit-type31.jpg',
          '/images/products/guardrail/height-limit-type32.jpg',
        ]}
      />

      <SectionDivider />

      <InfoSection
        title="제품 유형"
      >
        <TypeBlock groups={typeGroups} compact />
      </InfoSection>


      <InfoSection title="제품 특징">
        <FeatureList features={features} />
      </InfoSection>

      <ProductDetailNav
        category="guardrail"
        currentPath="/products/guardrail/height-limit"
        listPath="/products/guardrail"
      />


      <CTASection />
    </>
  );
};

export default HeightLimit;
